import {formatParams} from '../../Helper';

const urlParams = formatParams(window.location.search);
let defaultLocation = '';
let searchTxt = '';
let location = '';
let locationType = '';
let locationValue = '';
let locationTxt = '';

if(urlParams!==null){
  if(
    typeof urlParams.type !== "undefined" &&
    typeof urlParams.label !== "undefined"
  ){
    defaultLocation = `{"name":"${urlParams.type}", "value":"${urlParams.[urlParams.type]}","label":"${urlParams.label}"}`;
    location = JSON.parse(defaultLocation);
    locationType = location.name ? location.name : '';
    locationValue = location.value ? location.value : '';
    locationTxt = location.label ? location.label : '';
  }
  searchTxt = typeof urlParams.query !== "undefined" ? urlParams.query : '';
}

let initialState = {
  params: {
    categories:[],
    subcategories:[],
    limit: 18,
    from: 0,
    selectedCategory: [],
    selectedSubCategories: [],
    paymentMethods: [],
    deliveryMethods: [],
    specialCategories: [],
    search: searchTxt,
    location:location,
    locationTxt:locationTxt,
    locationType:locationType,
    locationValue:locationValue,
    filters: {
      womanPyme: false,
      cooperative: false,
      shipingProducts: false,
      pickup: false,
      paymentMethodCash: false,
      paymentMethodCreditDebitCard: false,
      paymentMethodTransfers: false
    }
  }
};

let paramsStr = localStorage.getItem('params');
if(paramsStr!==null){
  initialState = {
    params: JSON.parse(paramsStr)
  };
}

export default (state = initialState, action) => {
  if(action.type === 'UPDATE_PARAMS') {
    return {
      ...state,
      params: action.payload
    }
  }

  return state;
}

export const getParams = (state) => {
    return state.paramsReducer.params;
};
